module.exports = __webpack_public_path__ + "90be1b8efc13145561ec32beb122b875.png";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/arrow_right_current.png
// module id = 278
// module chunks = 0